import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, MenuItem, Typography } from '@mui/material';
import { DefaultCheckBox } from 'src/components';
import { CollapsibleSubCategoryRow } from 'src/components/SubCategoriesTable/components';
import {
  PenMenuIcon,
} from 'src/Icons';
import { DrawerServicesCategoryIcon } from 'src/Icons/DrawerServicesCategoryIcon';
import { CustomActionCardMenu } from 'src/screens/services/components';

export const CollapsibleCategoryRow = ({
  category,
  title,
  isChecked,
  checkedCategory,
  onCategoryCheckChange,
  onServiceCheckChange,
  withoutEditing = false,
  withSelection = false,
}: any) => {

  const normalizedServices = category?.services?.map((service: any) => {
    return {
      category,
      subCategory: null,
      ...service,
    };
  });

  const [isAccordeonOpened, setIsAccordeonOpened] = useState(true);

  const handleChangeCollapse = () => {
    setIsAccordeonOpened(!isAccordeonOpened);
  }

  const customAccordeonSummarySx = {
    backgroundColor: 'rgba(255,245,248, 0.6)',
    padding: 0,
    minHeight: '40px',
    '&.Mui-expanded': {
      margin: '0px',
      minHeight: '40px',
    },
    '& .Mui-expanded': {
      margin: '0px !important',
    }
  };

  return (
    <Accordion
      expanded={isAccordeonOpened}
      onChange={handleChangeCollapse}
      sx={{
        padding: 0,
        boxShadow: 0,
        width: 'fit-content',
        '&.Mui-expanded': {
          margin: '0',
        },
        '&:before': {
          opacity: 0,
        }
      }}
    >
      <AccordionSummary sx={{
        minWidth: '1230px',
        backgroundColor: '#FFF3F6',
        padding: 0,
        minHeight: '48px',
        cursor: 'pointer',
        '&.Mui-expanded': {
          margin: '0px',
          minHeight: '48px',
        },
        '& .Mui-expanded': {
          margin: '0px !important',
        },
      }}>
        {
          withSelection ? (
            <DefaultCheckBox
              isChecked={isChecked}
              onChange={(event) => {
                event.stopPropagation();
                onCategoryCheckChange(category);
              }}
              sx={{
                // width: '16px',
                // height: '16px',
                marginLeft: '12px',
                marginRight: '0px',
                backgroundColor: '#fff'
              }}
            />
          ) : null
        }
        <Box sx={{
          margin: '0px 8px',
          display: 'flex',
          alignItems: 'center',
        }}>
          <DrawerServicesCategoryIcon
            sx={{
              color: "#BF295C",
              width: "18px",
              height: "18px",
              marginRight: "5px",
            }}
          />
        </Box>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
        }}>
          <Typography sx={{
            color: '#363636',
            textTransform: 'uppercase',
            fontSize: '14px',
            fontWeight: '500',
          }}>
            {title}
          </Typography>
        </Box>
        {
          !withoutEditing ? (
            <Box sx={{
              display: 'flex',
              flexGrow: 1,
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}>
              <CustomActionCardMenu
                data={category}
                icon={<IconButton
                  onClick={() => {}}
                  sx={{
                    width: "16px",
                    height: "16px",
                    color: "#363636",
                    fontSize: "16px",
                  }}
                  disableRipple
                >
                  <PenMenuIcon fontSize="inherit" />
                </IconButton>}
              />
            </Box>
          ) : null
        }
      </AccordionSummary>
      <AccordionDetails sx={{
        padding: '0px',
      }}>
        {category?.children?.map((subCategory: any) => {
          const normalizedServices = subCategory?.services?.map((service: any) => {
            return {
              category,
              subCategory,
              ...service,
            };
          });

          const exists = checkedCategory?.children?.find((el: any) => el.id === subCategory.id);

          return (<CollapsibleSubCategoryRow
            key={subCategory?.title}
            title={subCategory?.title}
            services={normalizedServices}
            onServiceCheckChange={onServiceCheckChange}
            checkedSubCategory={exists}
            accordeonSummarySx={customAccordeonSummarySx}
            withSelection={withSelection}
          />);
        })}
        {category?.services?.length ? (
          <CollapsibleSubCategoryRow
            title={'No subcategory'}
            services={normalizedServices}
            onServiceCheckChange={onServiceCheckChange}
            checkedSubCategory={checkedCategory}
            accordeonSummarySx={customAccordeonSummarySx}
            withSelection={withSelection}
          />
        ) : null}
      </AccordionDetails>
    </Accordion>
  )
}
